// import 'default-passive-events';
import App from './App'
import AppM from './AppM'

import store from './store/index'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'

import { ConfigProvider } from 'antd'
// 兼容360浏览器
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs'

import 'dayjs/locale/zh-cn'
import locale from 'antd/locale/zh_CN'

import { isMobileFu } from './utils/history'

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)

// 和three通信
window.threeReact.state3d = val => {
  const nowSta = store.getState().three.state3d
  if (nowSta === val) return
  store.dispatch({ type: 'three/state3d', payload: val })
}

root.render(
  <ConfigProvider
    locale={locale}
    theme={{
      token: {
        colorPrimary: '#f58543'
      }
    }}
  >
    <Provider store={store}>
      <StyleProvider hashPriority='high' transformers={[legacyLogicalPropertiesTransformer]}>
        {/* 渲染 移动端 或 pc端 */}
        {isMobileFu() ? <AppM /> : <App />}
      </StyleProvider>
    </Provider>
  </ConfigProvider>
)
